module.exports = __webpack_public_path__ + "img/djibouti.247462d5.png";